import styled, { css } from 'styled-components';
import { ModalHeader, ModalSubHeaderStyled } from '@bechtel/gds';

export const ModalHeaderStyled = styled(ModalHeader)`
  background: ${({ theme }) => theme.colors.bechtel.blue[800]};
  h1 {
    color: ${({ theme }) => theme.colors.white};
    font-weight: ${({ theme }) => theme.fontWeights[600]};
  }
  button {
    background: none;
    color: ${({ theme }) => theme.colors.white};
    &:hover {
      background-color: ${({ theme }) => theme.colors.bechtel.blue[800]};
    }
  }
`;

export const ModalSubHeader = styled(ModalSubHeaderStyled)`
  ${({ theme }) => css`
    padding: ${theme.spacings[550]} ${theme.spacings[500]};
  `}
`;
